import { ArchiveRestore, ClipboardList, Database, HardDrive, GitBranch, Globe, FlaskConical, Activity, AppWindow, Bell, Bug, Coins, Gauge, HeartPulse, LayoutGrid, PieChart, PlugZap, ScrollText, type LucideIcon } from 'lucide-react';

// Navigation grouped by function. Every entry is singular, in the UI as in the route.

export interface NavItem {
  path: string;
  label: 'Overview' | 'Map' | 'Cost' | 'Application' | 'Error' | 'Log' | 'Health' | 'Usage' | 'Quota' | 'Query' | 'Alert' | 'Provider' | 'Test' | 'Segnalazione' | 'Recupero contatto' | 'Repository' | 'Host' | 'Database' | 'Backup';
  hint: string;
  icon: LucideIcon;
  shortcut: string;
}

export interface NavGroup {
  label: string | null;
  item: NavItem[];
}

export const NAVIGATION: NavGroup[] = [
  {
    label: null,
    item: [
      { path: '/overview', label: 'Overview', hint: 'Stato generale di tutta l’infrastruttura', icon: Gauge, shortcut: '1' },
      { path: '/map', label: 'Map', hint: 'Tutte le applicazioni da aprire in un unico punto', icon: LayoutGrid, shortcut: '0' },
    ],
  },
  {
    label: 'Operatività',
    item: [
      { path: '/application', label: 'Application', hint: 'Tutte le applicazioni e i servizi', icon: AppWindow, shortcut: '2' },
      { path: '/host', label: 'Host', hint: 'Mappa degli indirizzi: l’indirizzo vero di ogni applicazione e i suoi alias', icon: Globe, shortcut: 'h' },
      { path: '/repository', label: 'Repository', hint: 'Codice non committato e commit su git che non coincidono con l’ultimo rilascio', icon: GitBranch, shortcut: 'b' },
      { path: '/test', label: 'Test', hint: 'Test automatici e verifiche del deployment', icon: FlaskConical, shortcut: 't' },
      { path: '/health', label: 'Health', hint: 'Uptime, latency, risorse, endpoint e dipendenze', icon: HeartPulse, shortcut: '3' },
      { path: '/segnalazione', label: 'Segnalazione', hint: 'Bug e funzioni segnalati dal team, da approvare e correggere', icon: ClipboardList, shortcut: 'g' },
      { path: '/alert', label: 'Alert', hint: 'Anomalie, budget superati, errori improvvisi', icon: Bell, shortcut: '4' },
    ],
  },
  {
    label: 'Diagnosi',
    item: [
      { path: '/error', label: 'Error', hint: 'Eccezioni aggregate, stack trace, regressioni', icon: Bug, shortcut: '5' },
      { path: '/query', label: 'Query', hint: 'Query SQL di tutte le applicazioni: lente, pesanti o in peggioramento', icon: Database, shortcut: 'y' },
      { path: '/log', label: 'Log', hint: 'Ricerca centralizzata e CorrelationId', icon: ScrollText, shortcut: '6' },
      { path: '/lead-recovery', label: 'Recupero contatto', hint: 'Copia privata dei moduli ricevuti dal sito, solo amministratori', icon: ClipboardList, shortcut: 'r' },
    ],
  },
  {
    label: 'Dati',
    item: [
      { path: '/data', label: 'Database', hint: 'Tutti i database e gli archivi delle applicazioni, in 2D e in 3D', icon: HardDrive, shortcut: 'd' },
      { path: '/backup', label: 'Backup', hint: 'Backup automatici e ridondanti di tutti i dati, dimensioni e destinazioni', icon: ArchiveRestore, shortcut: 'k' },
    ],
  },
  {
    label: 'Consumi',
    item: [
      { path: '/cost', label: 'Cost', hint: 'Azure, Google, Cloudflare, OpenAI e altri', icon: Coins, shortcut: '7' },
      { path: '/usage', label: 'Usage', hint: 'Richieste, token, bandwidth, storage, DB, queue', icon: Activity, shortcut: '8' },
      { path: '/quota', label: 'Quota', hint: 'Consumi Cloudflare rispetto al piano Workers Paid', icon: PieChart, shortcut: 'q' },
    ],
  },
  {
    label: 'Configurazione',
    item: [{ path: '/provider', label: 'Provider', hint: 'Connessioni, credenziali, sincronizzazioni', icon: PlugZap, shortcut: '9' }],
  },
];

export const NAV_ITEM = NAVIGATION.flatMap((group) => group.item.map((item) => ({ ...item, group: group.label })));
